import { useState } from "react";

import Modal, { ModalSizes } from "../common/Modal";
import intl from "components/i18n/ReactIntlWrapper";
import { Box, Button, TextField, Typography, Stack } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

export type WorkflowCommentsOnSubmitProps = {
  input: string;
};
export type WorkflowCommentsModalProps = {
  isOpen: boolean;
  closeModal: any;
  onSubmit: WorkflowCommentsOnSubmitProps;
};

const WorkflowCommentsModal = ({ isOpen, onCloseModal, onSubmit }) => {
  const [input, setInput] = useState<string>("");

  const handleSave = async () => {
    if (onSubmit) {
      onSubmit(input);
    }
    onCloseModal();
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onCloseModal}
      size={ModalSizes.small}
      height="auto"
    >
      <Box p={3}>
        <Typography variant="h5" mb={2} textAlign="start">
          {intl.get("timeOffReject.title")}
        </Typography>

        <TextField
          fullWidth
          id="description"
          name="description"
          label={intl.get("timeOffReject.description")}
          placeholder={intl.get("timeOffReject.placeholder.description")}
          multiline
          rows={5}
          onChange={handleInputChange}
          margin="normal"
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
          <Button variant="outlined" color="inherit" onClick={onCloseModal}>
            {intl.get("cancel.button")}
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            <SaveIcon className="mb-1" /> {intl.get("save.button")}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default WorkflowCommentsModal;
